import { loadStripe, type Stripe } from '@stripe/stripe-js';

const promisesByKey = new Map<string, Promise<Stripe | null>>();

/**
 * `loadStripe` promises cached per publishable key at module scope, so repeated
 * dialog opens reuse the one Stripe.js script rather than defeating its cache.
 */
const getStripePromise = (publishableKey?: string) => {
	if (!publishableKey) {
		return undefined;
	}

	const cached = promisesByKey.get(publishableKey);

	if (cached) {
		return cached;
	}

	const promise = loadStripe(publishableKey);
	promisesByKey.set(publishableKey, promise);

	return promise;
};

export default getStripePromise;
